/*
 * TODO when any JS dependancy is done, change file type from
 *  .d.ts to .ts
 */

export enum ChargeTypes {
	Default,
	Help_Me_Choose,
	Skin_Diagnosis,
	Coaching = 4
}
